


















































import CompanyUserRequired from "../CompanyRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {companyroleid, PurchaseItem, PurchaseOrder, PurchaseOrderStatus} from "@/modules/models";
import OrderItemsList from "@/components/shop/OrderItemsList.vue";
import {postnumberValidator} from "@/modules/utils";
import rd from "@/modules/vRoutedefs";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-items-list": OrderItemsList,
    }
})
export default class OrderPage extends CompanyUserRequired {
    @Inject()
    api!: Api;

    @Prop()
    id!: number;

    @Prop({default: 0})
    chosenLocationId!: number;

    order: PurchaseOrder | null = null;

    loading = false;

    async addItemAmount(item: PurchaseItem) {
        item.amount = item.amount + 1;
        this.save();
    }
    async subItemAmount(item: PurchaseItem) {
        if(item.amount > 1) {
            item.amount = item.amount - 1;
        } else if(this.order) {
            this.order.items = this.order.items.filter(it => it !== item);
        }
        this.save();
    }

    validatePostnumber(postnum: string) {
        return postnum && postnumberValidator(postnum) || `Ugyldig postnr`;
    }

    validateSomeText(txt: string) {
        return txt && txt.length >= 2 || `Påkrevd tekstfelt`;
    }

    validateForm(): boolean {
        return (this.$refs["addrForm"] as any).validate() === true;
    }

    saving = false;
    async save() {
        if(this.order) {
             try {
                this.saving = true;
                 // save purchase order
                 await this.api.savePurchaseOrder(this.order);
             } finally {
                 this.saving = false;
             }
        }
    }

    async confirmOrder() {
        if(this.order && this.validateForm()) {
            try {
                this.saving = true;
                // set order status locked
                this.order.status = PurchaseOrderStatus.confirmed;
                // save purchase order
                await this.api.savePurchaseOrder(this.order);
                this.emitSnack(`Bestilling bekreftet`, "success");
                if(this.chosenLocationId > 0) { // Display chosen location id
                    await ignoreRedundantNavErr(this.$router.push({name: rd.locations.location.name, params: {locationId: this.chosenLocationId.toString()}}));
                }
            } finally {
                this.saving = false;
            }
        }
    }

    async deleteOrder() {
        if(this.order && this.order.id > 0 && this.order.status < PurchaseOrderStatus.confirmed) {
            try {
                this.saving = true;
                await this.api.deletePurchaseOrder(this.order.id);
                this.emitSnack(`Bestilling slettet`);
                await ignoreRedundantNavErr(this.$router.replace(this.shopTo));
            } finally {
                this.saving = false;
            }
        }
    }

    get shopTo() {
        return {name: rd.shop.name};
    }

    async changed() {
        await this.save();
    }

    @Watch("id", {immediate: true})
    async onIdChanged() {
        this.loading = true;
        try {
            this.order = await this.api.getPurchaseOrder(this.id);
            if(this.order == null) {
                this.emitSnack(`Bestilling ${this.id} ikke funnet`, "warning");
                await ignoreRedundantNavErr(this.$router.replace(this.shopTo));
            }
        } finally {
            this.loading = false;
        }
    }

    created() {
        this.requireCompanyRoles([companyroleid.admin]);
    }
}
